import { FaHandPointRight } from "react-icons/fa";

const About = () => {
    return (
        <section id='about'>
            <h2>Katılım Şartları</h2>
            {/* <p>
                <strong>Etkinliğe dahil edilme kriterleri:</strong>
            </p> */}
            <ul>
                <li>
                    <span><FaHandPointRight /></span> <span>4. sınıf hemşirelik lisans öğrencisi olmak</span>
                </li>
                <li>
                    <span><FaHandPointRight /></span> <span>Akademik başarı ortalaması 2.00 veya üstünde olmak</span>
                </li>
                <li>
                    <span><FaHandPointRight /></span> <span>2237 - Bilimsel Eğitim Etkinliklerini Destekleme Programı kapsamında desteklenen bir proje eğitimine katılmamış olmak</span>
                </li>
                <li>
                    <span><FaHandPointRight /></span> <span>TÜBİTAK ARBİS veri tabanına kayıtlı olmak</span>
                </li>
                <li>
                    <span><FaHandPointRight /></span> <span>Eğitime katılmaya gönüllü ve istekli olmak</span>
                </li>
            </ul>
        </section>
    )
}

export default About